// src/components/SEO.jsx
import { Helmet } from "react-helmet"

const SITE_URL = "https://2merative.com"

const absolute = (url = "") =>
  url.startsWith("http") ? url : `${SITE_URL}${url}`

export default function SEO({
  title = "2merative Web Design Adelaide",
  description = "Web design Adelaide services for businesses that need a clear, credible, conversion-focused website.",
  path = "/",
  image = "/og-image.png",
  noindex = false,
}) {
  const url = absolute(path)
  const ogImage = absolute(image)

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "2merative",
    url: SITE_URL,
    logo: absolute("/favicon-2merative-512.png"),
    sameAs: [
      "https://www.facebook.com/2merative",
      "https://www.instagram.com/2merative",
      "https://www.linkedin.com/company/2merative",
    ],
  }

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: "2merative",
    image: ogImage,
    url,
    logo: absolute("/favicon-2merative-512.png"),
    areaServed: [
      {
        "@type": "City",
        name: "Adelaide",
      },
      {
        "@type": "State",
        name: "South Australia",
      },
    ],
    address: {
      "@type": "PostalAddress",
      addressLocality: "Adelaide",
      addressRegion: "SA",
      addressCountry: "AU",
    },
    priceRange: "$$",
  }

  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "2merative",
    url: SITE_URL,
  }

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="theme-color" content="#0A2343" />
      <meta name="robots" content={noindex ? "noindex,nofollow" : "index,follow"} />

      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="2merative" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(localBusinessSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(websiteSchema)}
      </script>
    </Helmet>
  )
}